export const documentStatus = [
    {
        status: 'PENDENTE',
        color: '#f44336'
    },
    {
        status: 'REPROVADO',
        color: '#f44336'
    },
    {
        status: 'A VALIDAR',
        color: '#ffa500'
    },
    {
        status: 'VALIDADO',
        color: '#4caf50'
    },
    {
        status: 'N/S',
        color: '#9e9e9e'
    }
];
